import ProcessEngineType from 'library/src/processing/models/ProcessEngineType';
import {AddVisioCropFieldUse} from 'library/src/visio_crop/models/AddVisioCropFieldUse';

export const BASE_VISIOCROP_FIELD_USE: AddVisioCropFieldUse<any> = {
  crop_id: 0,
  harvest_date: '',
  sowing_date: '',
  cropping_system_id: 0,
  processing_engine_ref: ProcessEngineType.VC_RAPESEED_FERTILIZATION,
  parameters: {},
};

export const ALLOWED_VISIO_CROP_PROCESSING_ENGINES: ProcessEngineType[] = [
  ProcessEngineType.VC_RAPESEED_FERTILIZATION,
  //ProcessEngineType.VC_PHENOLOGY,
];
